import { ref, computed, watchEffect } from "vue";
import { useLogin } from "./login";
import { defineStore } from "pinia";

export const useTimeListLogic = defineStore("TimeListLogic", () => {
  const login = useLogin();
  function DateString(Date: Date) {
    const year = Date.getFullYear();
    const month = String(Date.getMonth() + 1).padStart(2, "0"); // 月份从 0 开始，所以需要加 1
    const day = String(Date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  function getCashTypeToday() {
    const today = new Date();
    const currentHour = today.getHours();

    if (login.isCashMember) {
      // 如果是 cashMember，直接回傳今天的日期
      return today;
    } else {
      // 如果不是 cashMember，只有中午12點後才回傳今天的日期
      if (currentHour >= 12) {
        return today;
      } else {
        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1); // 回傳昨天的日期
        return yesterday;
      }
    }
  }

  function getDataDate(Day: number) {
    // const todayDate = new Date();
    const todayDate = getCashTypeToday();
    todayDate.setDate(todayDate.getDate() - todayDate.getDay() + Day);
    // const DateDate = todayDate.toISOString().split("T")[0];
    return DateString(todayDate);
  }

  function getMonthFirthDate() {
    // const today = new Date();
    const today = getCashTypeToday();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // 加1是因為getMonth()返回的是0到11

    return `${year}-${month}-01`;
  }

  function getMonthLastDate() {
    // const today = new Date();
    const today = getCashTypeToday();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const EndDay = getCashTypeEndTimeDay(0);
    const lastDayOfMonth = new Date(year, month, EndDay);

    // const formattedLastDay = lastDayOfMonth.toISOString().split("T")[0];

    return DateString(lastDayOfMonth);
  }

  function getTodayDay() {
    // const today = new Date();
    const today = getCashTypeToday();
    return today.getDay();
  }

  function getCashTypeEndTimeDay(day: number) {
    if (login.isCashMember) return day;
    return day + 1;
  }

  return {
    DateString,
    getCashTypeToday,
    getDataDate,
    getMonthFirthDate,
    getMonthLastDate,
    getTodayDay,
    getCashTypeEndTimeDay,
  };
});
